import TemplateGov from './TemplateGov'
import TemplateCorporate from './TemplateCorporate'
import RetailInvoice from './RetailInvoice'
import MinimalInvoice from './MinimalInvoice'
import Custom from './Custom';
import { companyConfig } from '../../../config/companyConfig';

const InvoicePage = ({ template, invoice }) => {
  switch (template) {
    case "gov":
      return <TemplateGov invoice={invoice} seller={companyConfig}/>;
    case "corporate":
      return <TemplateCorporate invoice={invoice} seller={companyConfig}/>;
    case "retail":
      return <RetailInvoice invoice={invoice} seller={companyConfig}/>;
    case "minimal":
      return <MinimalInvoice invoice={invoice} seller={companyConfig}/>;
    case "custom":
    default:
      return <Custom invoice={invoice} />;
  }
};

export default InvoicePage;
